class LoveLanceProductTabs extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    this.dataset.initialized = 'true';
  }

  activate(activeTab) {
    this.tabs.forEach((tab) => {
      const active = tab === activeTab;
      tab.setAttribute('aria-selected', String(active));
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== activeTab.getAttribute('aria-controls');
    });
  }

  onKeydown(event, index) {
    const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (!keys.includes(event.key)) return;

    event.preventDefault();
    let nextIndex = index;
    if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;

    this.tabs[nextIndex].focus();
    this.activate(this.tabs[nextIndex]);
  }
}

if (!customElements.get('lovelance-product-tabs')) {
  customElements.define('lovelance-product-tabs', LoveLanceProductTabs);
}
